import { createSelector } from '@ngrx/store';

import { CurrentUserSelectors } from '@ninety/platform/state';

import { DEFAULT_DIALOG_MODE } from '../../services/create-dialog.service';

export const selectUserDialogModePreference = createSelector(
  CurrentUserSelectors.selectUser,
  user => user.settings?.dialogModePreference || DEFAULT_DIALOG_MODE
);
